/**
 * Spoken responses for the global voice assistant.
 *
 * Delegates to the shared TtsManager (V3-TTS-MANAGER) so playback is
 * generation-safe across rail, overlay, and dedicated page.
 */

import { getSharedTtsManager } from '../voice/ttsManager';

/** Stop any in-flight assistant speech (audio element or browser synthesis). */
export const stopSpeaking = (): void => {
  getSharedTtsManager().stop('legacy-stopSpeaking');
};

/**
 * Speak an assistant response. No-op in silent mode or for empty text.
 * Never throws — TTS failures must not break the conversation flow.
 */
export const speakResponse = async (text: string): Promise<void> => {
  try {
    await getSharedTtsManager().speak(text);
  } catch (err) {
    console.warn('TTS speak failed:', err);
  }
};
